var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Data Deletion")]),_c('p',[_vm._v("Please contact us at info@igloocreations.com so we can proceed with your request.")]),_c('p',[_vm._v("Thank you!")])])
}]

export { render, staticRenderFns }